export default function LocationsSection() {
  const handleGetDirections = () => {
    window.open('https://www.google.com/maps/search/Sakura+Sushi+House+Juarez', '_blank');
  };

  const handleCall = () => {
    window.location.href = 'tel:+526561234567';
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12">
          {/* About Section */}
          <div>
            <h2 className="text-3xl font-bold mb-6">About Sakura Sushi House</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Fresh sushi and traditional Japanese dishes crafted with precision and care. Our experienced chefs use only the finest ingredients to create authentic Japanese cuisine that delights both sushi enthusiasts and newcomers alike.
            </p>
            <p className="text-gray-700 mb-6 leading-relaxed">
              From our signature dragon rolls to our hearty ramen bowls, every dish is prepared with attention to detail and respect for Japanese culinary traditions. Whether you're here for a quick lunch or a leisurely dinner, we promise an authentic taste of Japan in the heart of Juarez.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-restaurant-line text-teal-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-1">Fresh Sushi Daily</h3>
                  <p className="text-gray-600">Premium quality fish and ingredients sourced fresh daily</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-bowl-line text-teal-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-1">Authentic Ramen</h3>
                  <p className="text-gray-600">Rich, flavorful broths simmered for hours</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-leaf-line text-teal-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-1">Vegetarian Options</h3>
                  <p className="text-gray-600">Delicious plant-based sushi and dishes available</p>
                </div>
              </div>
            </div>
          </div>

          {/* Location Details */}
          <div>
            <div className="bg-gray-50 rounded-lg p-8 mb-6">
              <h3 className="text-2xl font-bold mb-6">Location & Hours</h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center">
                    <i className="ri-map-pin-line text-teal-600 text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Address</h4>
                    <p className="text-gray-700">Av. Tecnológico 3450<br/>Col. Fuentes del Valle<br/>Juárez, Chihuahua</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center">
                    <i className="ri-phone-line text-teal-600 text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Phone</h4>
                    <a href="tel:+526561234567" className="text-teal-600 hover:underline">
                      +52 656 123 4567
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center">
                    <i className="ri-time-line text-teal-600 text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-2">Hours</h4>
                    <div className="space-y-1 text-sm text-gray-700">
                      <p>Monday - Thursday: 1:00 PM - 10:00 PM</p>
                      <p>Friday - Saturday: 1:00 PM - 11:00 PM</p>
                      <p>Sunday: 1:00 PM - 9:00 PM</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mt-8 flex gap-4">
                <button
                  onClick={handleGetDirections}
                  className="flex-1 bg-teal-600 text-white px-6 py-3 rounded-lg hover:bg-teal-700 transition-colors font-semibold whitespace-nowrap cursor-pointer"
                >
                  Get Directions
                </button>
                <button
                  onClick={handleCall}
                  className="flex-1 border-2 border-teal-600 text-teal-600 px-6 py-3 rounded-lg hover:bg-teal-50 transition-colors font-semibold whitespace-nowrap cursor-pointer"
                >
                  Call Now
                </button>
              </div>
            </div>
            
            {/* Map */}
            <div className="rounded-lg overflow-hidden h-[300px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3407.8!2d-106.43!3d31.73!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzHCsDQzJzQ4LjAiTiAxMDbCsDI1JzQ4LjAiVw!5e0!3m2!1sen!2smx!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Sakura Sushi House Location"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
